export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "quality_inspect": {
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha"])},
            "samplings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Muestras"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor"])},
            "quality_accepted_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% de calidad"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])},
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hora de inicio"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hora de fin"])}
          }
        }
      },
      "en": {
        "model": {
          "quality_inspect": {
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registered at"])},
            "samplings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Samplings"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Week"])},
            "provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provider"])},
            "quality_accepted_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% of quality"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["observations"])},
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Started At"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished At"])}
          }
        }
      }
    }
  })
}